// extracted by mini-css-extract-plugin
module.exports = {"bannerTextWidth":"treatment_bannerTextWidth__1qd1w","pusherDiv":"treatment_pusherDiv__uWFiM"};